import { render, staticRenderFns } from "./PaymentStateChip.vue?vue&type=template&id=4741a210&"
import script from "./PaymentStateChip.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PaymentStateChip.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports